import { render, staticRenderFns } from "./AddGroupForm.vue?vue&type=template&id=b4507c74&"
import script from "./AddGroupForm.vue?vue&type=script&lang=js&"
export * from "./AddGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports